var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.334,
    height: 22,
    viewBox: "0 0 29.334 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #73b9ff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-video-call_2_",
    "data-name": "icons8-video-call (2)",
    className: "cls-1",
    d: "M24.533,26.233A4.767,4.767,0,0,1,19.767,31h-11A4.767,4.767,0,0,1,4,26.233V13.767A4.767,4.767,0,0,1,8.767,9h11a4.767,4.767,0,0,1,4.767,4.767Zm8.242-14.157a1.1,1.1,0,0,0-1.108.014L26,15.491v9.019l5.668,3.4a1.1,1.1,0,0,0,1.665-.943V13.033A1.1,1.1,0,0,0,32.775,12.076Z",
    transform: "translate(-4 -9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoFilled);
export default __webpack_public_path__ + "static/media/videoFilled.82090c169e745432b62f23c935592d83.svg";
export { ForwardRef as ReactComponent };